import React from 'react';
import ReactDOM from "react-dom";
import Router from "./Router";
import UserContextProvider from "./contexts/UserContext";
import PageContextProvider from "./contexts/PageContext";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/styles";

import { theme } from "./theme";
import "./style.css";

ReactDOM.render( 
  <UserContextProvider>
    <PageContextProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router />
      </ThemeProvider>
    </PageContextProvider>
  </UserContextProvider>
  , document.getElementById("root"));